export default function popupBoleto() {

  $('[data-popups="content"]').each(function (index, el) {
    const id = $(el).attr('data-id');
    const content = $(el);
    const close = $(el).find('[data-popups="close"]');

    if (!getCookie('popups_' + id)) {
      content.show();
    }

    close.click(() => {
      content.hide();
      setCookie('popups_' + id, true, 7)
    });

  });

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}